'use client';

import { c as _c } from "react/compiler-runtime";
import { usePageAction } from '@cc-shopping/platform-analytics/hooks/usePageAction';
import { useCompareBar } from './Context';
export const useCompareBarAnalyticsEvents = () => {
  const $ = _c(20);
  const {
    idsToCompare
  } = useCompareBar();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      actionName: "compare_card",
      actionSection: "ru_compare_footer",
      actionType: "add"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const fireAddCardPageAction = usePageAction(t0);
  let t1;
  if ($[1] !== fireAddCardPageAction) {
    t1 = productName => {
      fireAddCardPageAction({
        additional_attributes: {
          sku_name: productName
        }
      });
    };
    $[1] = fireAddCardPageAction;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const fireAddCardAnalyticsEvents = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      actionName: "compare_card",
      actionSection: "ru_compare_footer",
      actionType: "remove"
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const fireRemoveCardPageAction = usePageAction(t2);
  let t3;
  if ($[4] !== fireRemoveCardPageAction) {
    t3 = productName_0 => {
      fireRemoveCardPageAction({
        additional_attributes: {
          sku_name: productName_0
        }
      });
    };
    $[4] = fireRemoveCardPageAction;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const fireRemoveCardAnalyticsEvents = t3;
  let t4;
  if ($[6] !== idsToCompare.length) {
    t4 = idsToCompare.length.toString();
    $[6] = idsToCompare.length;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = {
      actionName: "compare_selection",
      actionSection: "ru_compare_footer",
      actionType: "select",
      actionInput: t4
    };
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const fireClickComparePageAction = usePageAction(t5);
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      actionName: "compare_clear",
      actionSection: "ru_compare_footer",
      actionType: "select"
    };
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const fireClearAllPageAction = usePageAction(t6);
  let t7;
  if ($[11] !== fireAddCardAnalyticsEvents) {
    t7 = productName_1 => fireAddCardAnalyticsEvents(productName_1);
    $[11] = fireAddCardAnalyticsEvents;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== fireRemoveCardAnalyticsEvents) {
    t8 = productName_2 => fireRemoveCardAnalyticsEvents(productName_2);
    $[13] = fireRemoveCardAnalyticsEvents;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== fireClearAllPageAction || $[16] !== fireClickComparePageAction || $[17] !== t7 || $[18] !== t8) {
    t9 = {
      add: t7,
      remove: t8,
      clickCompare: fireClickComparePageAction,
      clearAll: fireClearAllPageAction
    };
    $[15] = fireClearAllPageAction;
    $[16] = fireClickComparePageAction;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
};